import { call, put, takeLatest } from "@redux-saga/core/effects";
import { VendorConstant } from "./vendorConstant";
import { VendorApi } from "./vendoApi";
import { VendorParser } from "./vendorParser";

function* getVendorCity() {
  try {
    yield put({ type: VendorConstant.VENDOR_CITY_REQUEST });

    const res = yield call(VendorApi.getVendorCity);

    const payload = res;

    yield put({
      type: VendorConstant.VENDOR_CITY_RESPONSE,
      payload: payload,
    });
  } catch (e) {
    console.log(e);
    yield put({
      type: VendorConstant.VENDOR_CITY_RESPONSE,
      payload: [],
    });
  }
}

function* getVendorRequest() {
  try {
    yield put({ type: VendorConstant.VENDOR_SEEALLRES_REQUEST });

    const res = yield call(VendorApi.getVendorSeeAllRequest);

    const payload = VendorParser.vendorSeeAllRequest(res);

    yield put({
      type: VendorConstant.VENDOR_SEEALLRES_RESPONSE,
      payload: res,
    });
  } catch (e) {
    console.log(e);
    yield put({
      type: VendorConstant.VENDOR_SEEALLRES_RESPONSE,
      payload: [],
    });
  }
}

function* getVendorCount() {
  try {
    yield put({ type: VendorConstant.VENDOR_COUNT_REQUEST });

    const res = yield call(VendorApi.ApigetVendorCount);

    const payload = res;

    yield put({
      type: VendorConstant.VENDOR_COUNT_RESPONSE,
      payload: payload,
    });
  } catch (e) {
    console.log(e);
    yield put({
      type: VendorConstant.VENDOR_COUNT_RESPONSE,
      payload: [],
    });
  }
}

function* getVendorApprovesaga({ payload }) {
  try {
    yield put({ type: VendorConstant.APPROVE_ENABLE_DISABLE_REQUEST });
    const res = yield call(VendorApi.postApproveRequestApi, payload);
    yield put({
      type: VendorConstant.APPROVE_ENABLE_DISABLE_RESPONSE,
      payload: res,
    });
  } catch (e) {
    yield put({
      type: VendorConstant.APPROVE_ENABLE_DISABLE_RESPONSE,
      payload: [],
    });
  }
}

//Reject request vendor
function* getVendorRejectsaga({ payload }) {
  try {
    yield put({ type: VendorConstant.REJECT_ENABLE_DISABLE_REQUEST });
    const res = yield call(VendorApi.postRejectRequestApi, payload);
    yield put({
      type: VendorConstant.REJECT_ENABLE_DISABLE_RESPONSE,
      payload: res,
    });
  } catch (e) {
    yield put({
      type: VendorConstant.REJECT_ENABLE_DISABLE_RESPONSE,
      payload: [],
    });
  }
}

// vendor list enable disable saga
function* getVendorListsaga({ payload }) {
  try {
    yield put({ type: VendorConstant.VENDOR_ENABLE_DISABLE_REQUEST });
    const res = yield call(VendorApi.postVendorListApi, payload);
    yield put({
      type: VendorConstant.VENDOR_ENABLE_DISABLE_RESPONSE,
      payload: res,
    });
  } catch (e) {
    yield put({
      type: VendorConstant.VENDOR_ENABLE_DISABLE_RESPONSE,
      payload: [],
    });
  }
}

export function* registerVendorSaga() {
  yield takeLatest(VendorConstant.VENDOR_CITY_SAGA, getVendorCity);
  yield takeLatest(VendorConstant.VENDOR_SEEALLRES_SAGA, getVendorRequest);
  yield takeLatest(VendorConstant.VENDOR_COUNT_SAGA, getVendorCount);
  yield takeLatest(
    VendorConstant.APPROVE_ENABLE_DISABLE_SAGA,
    getVendorApprovesaga
  );
  yield takeLatest(
    VendorConstant.REJECT_ENABLE_DISABLE_SAGA,
    getVendorRejectsaga
  );
  yield takeLatest(
    VendorConstant.APPROVE_ENABLE_DISABLE_SAGA,
    getVendorListsaga
  );
}
